import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { defaultOrQueryDate } from '../../utils/QueryParser'
import CommunityChartView from './CommunityChartView'
import * as CommunityActionCreators from '../../actions/community'
import * as TimeseriesActionCreators from '../../actions/timeseries'
import * as EventActionCreators from '../../actions/event'

class CommunityChartContainer extends React.Component {
  static propTypes = {
    communityId: PropTypes.number.isRequired,
    unitsByCommunity: PropTypes.object.isRequired,
    communityActions: PropTypes.object.isRequired,
    timeseries: PropTypes.object.isRequired,
    timeseriesByUnit: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
    events: PropTypes.object.isRequired,
    eventActions: PropTypes.object.isRequired,
    units: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      unitsByCommunity: state.unitsByCommunity,
      timeseries: state.timeseries,
      timeseriesByUnit: state.timeseriesByUnit,
      events: state.events,
      units: state.units,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      communityActions: bindActionCreators(CommunityActionCreators, dispatch),
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
      eventActions: bindActionCreators(EventActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.update()
  }

  componentDidUpdate() {
    this.update()
  }

  filterTimeseries = (timeseries, name) => (
    timeseries.filter((ts) => ts.name === name && ts.internal === false)
  )

  update() {
    const {
      communityId, communityActions, timeseriesActions, eventActions, events,
    } = this.props
    communityActions.listCommunityUnits(communityId)
    this.unitIds().forEach((unitId) => {
      timeseriesActions.listUnitTimeseries(unitId)
    })
    this.energyTimeseries().forEach((ts) => {
      if (ts && !events[ts.id]) {
        eventActions.listEvents(ts.id)
      }
    })
  }

  unitIds() {
    const {
      unitsByCommunity, communityId,
    } = this.props
    return unitsByCommunity[communityId] || []
  }

  energyTimeseries() {
    const {
      timeseries, timeseriesByUnit,
    } = this.props
    const tsIds = []
    this.unitIds().forEach((unitId) => {
      const ts = timeseriesByUnit[unitId]
      if (ts) {
        tsIds.push(...ts)
      }
    })
    return this.filterTimeseries(tsIds.map((id) => (timeseries[id])), 'energy/power')
  }

  energyEvents() {
    const timeseriesEvents = {}
    const energyTimeseries = this.energyTimeseries()
    energyTimeseries.forEach((ts) => {
      if (ts && ts.id) {
        timeseriesEvents[ts.id] = this.props.events[ts.id] || []
      }
    })
    return timeseriesEvents
  }

  render() {
    const events = this.energyEvents()
    const length = Object.values(events).reduce((acc, arr) => acc + arr.length, 0)
    if (length > 0) {
      const [from, to] = defaultOrQueryDate()
      return (
        <CommunityChartView
          events={events}
          timeseries={this.energyTimeseries()}
          units={this.props.units}
          size="half_height"
          timeMin={from}
          timeMax={to}
        />
      )
    }
    return null
  }
}

export default connect(
  CommunityChartContainer.mapStateToProps,
  CommunityChartContainer.mapDispatchToProps,
)(CommunityChartContainer)
